// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ceb39ca3e7db978c9 {\r\n    padding: 20px;\r\n}", "",{"version":3,"sources":["webpack://./src/Modal/PrivacyInfo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".privacyInfo {\r\n    padding: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"privacyInfo": "ceb39ca3e7db978c9"
};
export default ___CSS_LOADER_EXPORT___;
